import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdvanceTransactionApi,
  saveAdvanceTranApi,
  deleteAdvanceTranApi,
  getContraCodeApi,
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

export const fetchAdvanceTransactionList = createAsyncThunk(
  "advanceTransaction/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAdvanceTransactionApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createOrUpdateAdvanceTransaction = createAsyncThunk(
  "advanceTransaction/createOrUpdate",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveAdvanceTranApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteAdvanceTransaction = createAsyncThunk(
  "advanceTransaction/delete",
  async (tran_id, { rejectWithValue }) => {
    try {
      const res = await deleteAdvanceTranApi({ tran_id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchContraCode = createAsyncThunk(
  "advanceTransaction/fetchContraCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getContraCodeApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchFromAccounts = createAsyncThunk(
  "advanceTransaction/fetchFromAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["cash_in_hand", "bank_account"],
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// export const fetchToAccounts = createAsyncThunk(
//     "advanceTransaction/fetchToAccounts",
//     async (acc_type,text, { rejectWithValue }) => {
//         try {
//             //   const res = await getAccountBySeachApi({
//             //     multiType: [acc_type],
//             //   });
//             const res = await getAccountBySeachApi({
//                 query: text.trim(),
//                 type: acc_type,
//                 // acc_type_name: accountTypes
//             });

//             return res.data;
//         } catch (err) {
//             return rejectWithValue(err.response?.data || err.message);
//         }
//     }
// );

export const fetchToAccounts = createAsyncThunk(
  "advanceTransaction/fetchToAccounts",
  async ({ acc_type, query }, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: query.trim(),
        type: acc_type,
        // acc_type_name: accountTypes
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
